import './index.less';
import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode, useEffect, useState } from 'react';

export interface SpinUIProps {
  isShow?: string;
  dot?: boolean;
  block?: boolean;
  loading?: boolean;
  delay?: number;
  tip?: ReactNode;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

const SpinUI: FC<SpinUIProps> = (props) => {
  const { dot, block, loading = true, delay, tip, className, style, children } = props;
  const [delayDone, setDelayDone] = useState(!delay);

  useEffect(() => {
    if (!loading || !delay) {
      setDelayDone(true);
      return;
    }

    setDelayDone(false);
    const timer = window.setTimeout(() => {
      setDelayDone(true);
    }, delay);

    return () => {
      window.clearTimeout(timer);
    };
  }, [delay, loading]);

  const shouldShowSpin = loading && delayDone;
  const spinNode = shouldShowSpin ? (
    <span className="spin-ui-indicator" aria-hidden="true">
      {dot ? (
        <span className="spin-ui-dot">
          <i />
          <i />
          <i />
          <i />
        </span>
      ) : (
        <span className="spin-ui-circle" />
      )}
    </span>
  ) : null;

  if (children) {
    return (
      <span
        className={classNames('spin-ui', block && 'spin-ui-block', loading && 'spin-ui-loading', className)}
        style={style}
      >
        {spinNode}
        {tip && shouldShowSpin ? <span className="spin-ui-tip">{tip}</span> : null}
        <span className="spin-ui-children">{children}</span>
      </span>
    );
  }

  return (
    <span
      className={classNames('spin-ui', block && 'spin-ui-block', loading && 'spin-ui-loading', className)}
      style={style}
      role={loading ? 'status' : undefined}
    >
      {spinNode}
      {tip && shouldShowSpin ? <span className="spin-ui-tip">{tip}</span> : null}
    </span>
  );
};

export default SpinUI;
